export const FETCH_DEFAULT_PRODUCT_SETTINGS = 'default_product_settings/FETCH_DEFAULT_PRODUCT_SETTINGS';